import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from '../services/api';

export default function PublicValidateDocumentPage() {
  const { code } = useParams();

  const [data, setData] = useState(null);
  const [fileResult, setFileResult] = useState(null);
  const [fileLoading, setFileLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const load = async () => {
      try {
      let res;

      try {
        res = await axios.get(
          `/contracts/public/validate/${code}`
        );
      }
      catch {

        res = await axios.get(
          `/prescriptions/public/validate/${code}`
        );

      }
        setData(res.data);
      } catch (e) {
        setError('Documento não encontrado ou inválido.');
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [code]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p>Validando documento...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center text-red-600">
        {error}
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-sm border max-w-lg w-full p-6">

        <div className="text-center mb-4">
          <div className="text-4xl">🔒</div>
          <h1 className="text-xl font-semibold mt-2">
            {data.status === 'revoked'
              ? 'Documento autêntico (revogado)'
              : 'Documento válido'}
          </h1>

          <p className="text-sm text-gray-600">
            {data.status === 'revoked'
              ? 'O documento foi assinado validamente, porém o consentimento foi posteriormente revogado.'
              : 'Assinatura verificada com sucesso'}
          </p>
        </div>

        <div className="space-y-2 text-sm text-gray-700">

          <div><strong>Título:</strong> {data.title}</div>
          <div><strong>Paciente:</strong> {data.patient_name}</div>
          <div><strong>Assinado por:</strong> {data.signer_name}</div>
          <div><strong>Data:</strong> {new Date(data.signed_at).toLocaleString()}</div>
          {data.signer_ip && data.signer_ip !== '-' && (
            <div>
              <strong>IP:</strong> {data.signer_ip}
            </div>
          )}
          <div>
            <strong>Status:</strong>{' '}
            {data.status === 'revoked'
              ? 'Revogado'
              : data.signature_status}
          </div>
          {data.status === 'revoked' && (
            <div className="mt-3 p-3 rounded border border-red-300 bg-red-50 text-red-800">
              <strong>Revogação registrada</strong>

              {data.revoked_at && (
                <div className="mt-1">
                  Data da revogação:{' '}
                  {new Date(data.revoked_at).toLocaleString()}
                </div>
              )}

              {data.revoked_reason && (
                <div className="mt-1">
                  Motivo: {data.revoked_reason}
                </div>
              )}
            </div>
          )}          
            {data.pdf_sha256 && (
            <div className="break-all">
                <strong>Hash SHA-256 do PDF:</strong> {data.pdf_sha256}
            </div>
            )}

            {data.signed_pdf_download_url && (
            <div className="mt-4 text-center">
                <a
                href={data.signed_pdf_download_url}
                target="_blank"
                rel="noreferrer"
                className="inline-flex px-4 py-2 rounded bg-purple-600 text-white text-sm hover:bg-purple-700"
                >
                Baixar PDF original assinado
                </a>
            </div>
            )}          

        </div>

        <div className="mt-6 border-t pt-4">

        <h3 className="text-sm font-semibold mb-2">
            Validar PDF original
        </h3>

        <input
            type="file"
            accept="application/pdf"
            onChange={async (e) => {
            const file = e.target.files[0];
            if (!file) return;

            const formData = new FormData();
            formData.append('file', file);

            setFileLoading(true);
            setFileResult(null);

            try {
                let res = await fetch('/api/contracts/public/validate-file', {
                  method: 'POST',
                  body: formData,
                });

                let result = await res.json();

                if (!result.valid) {
                  res = await fetch('/api/prescriptions/public/validate-file', {
                    method: 'POST',
                    body: formData,
                  });

                  result = await res.json();
                }

                setFileResult(result);
            } catch (err) {
                setFileResult({ valid: false, message: 'Erro ao validar arquivo' });
            } finally {
                setFileLoading(false);
            }
            }}
            className="mb-3"
        />

        {fileLoading && <p className="text-sm">Validando arquivo...</p>}

        {fileResult && (
            <div className={`p-3 rounded text-sm ${
            fileResult.valid ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'
            }`}>
            <strong>{fileResult.message}</strong>

            <div className="mt-2 break-all text-xs">
                Hash: {fileResult.sha256}
            </div>
            </div>
        )}

        </div>

        <div className="mt-4 p-3 bg-gray-50 border rounded text-xs text-gray-500 text-center">
          Código: {code}
        </div>

      </div>
    </div>
  );
}